export default __webpack_public_path__ + "static/roadmap-f7dc3c8296ebff5b59d34f485294ce9c.svg";